module.exports = __webpack_public_path__ + "imgs/safe-online-logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/img/safe-online-logo.jpg
// module id = 197
// module chunks = 0